import type { ComponentProps } from "react"

import { P2B } from "../Typographies"

type Props = React.PropsWithChildren<{ disabled?: boolean } & ComponentProps<typeof P2B>>

export default function FieldLabel({ children, disabled, color, ...p2bProps }: Props) {
  // An undefined color passed through (SingleField's labelColor) used to override the muted grey,
  // so some labels came out black and others grey.
  return (
    <P2B color={disabled ? "textSubtle" : (color ?? "textMuted")} {...p2bProps}>
      {children}
    </P2B>
  )
}
